import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { AUTH_PAGE_URL, BUYERS_PAGE_NAME, DOMAINS_PAGE_NAME } from '@/components/pages/routes'
import useLogout from '@/composables/useLogout'
import { useAuth } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter()

const logoutUser = () => {
  useLogout()
  window.location.href = AUTH_PAGE_URL
}
const store = useAuth()
const isAuthenticated = computed(() => store.is_authenticated)


const __returned__ = { router, logoutUser, store, isAuthenticated, computed, get useRouter() { return useRouter }, get AUTH_PAGE_URL() { return AUTH_PAGE_URL }, get BUYERS_PAGE_NAME() { return BUYERS_PAGE_NAME }, get DOMAINS_PAGE_NAME() { return DOMAINS_PAGE_NAME }, get useLogout() { return useLogout }, get useAuth() { return useAuth } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})